import MuiSnackbar from '@mui/material/Snackbar';
import MuiAlert from "@mui/material/Alert";
import { isEmpty } from "lodash";

const Snackbar = (props) => {
  // snackInfo/setSnackInfo 패턴과 기존 onClose/open/content/severity 패턴 모두 지원
  const { snackInfo, setSnackInfo, onClose, open: openProp, content: contentProp, duration, severity: severityProp } = props;

  const open     = snackInfo ? snackInfo.open     : openProp;
  const content  = snackInfo ? (snackInfo.message ?? snackInfo.content ?? "") : contentProp;
  const severity = snackInfo ? (snackInfo.color   ?? snackInfo.severity ?? "success") : severityProp;

  const handleClose = (_event, reason) => {
    if (reason === "clickaway") return;
    if (setSnackInfo) {
      setSnackInfo(prev => ({ ...prev, open: false }));
    } else if (onClose) {
      onClose();
    }
  }

  const Linebreak = (msg) => {
    if(isEmpty(msg)) {
      return "";
    }

    return msg.split(/\r\n|\r|\n/)
      .filter(item => !isEmpty(item))
      .map(str => <div key={str}> {str}<br /></div>)
  }

  return (
    <MuiSnackbar open={open} onClose={handleClose} autoHideDuration={duration ? duration : 10000} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
      <MuiAlert onClose={handleClose} variant="filled" severity={severity ? severity : "success"} elevation={6}>
        {Linebreak(content)}
      </MuiAlert>
    </MuiSnackbar>
  )
}

export default Snackbar;
